const styles = {
  label: {},
  title: {
    textAlign: 'left',
    fontFamily: 'Inter',
    color: 'kit.text.secondary',
    fontSize: {
      xs: '14px',
    },
    lineHeight: {
      xs: '20px',
    },
  },
  formControl: {
    width: '100%',
    color: '#666666',
  },
  formGroup: {
    flexDirection: 'row',
    // flexWrap: 'nowrap',
    marginTop: 0,
  },
  dropDown: {
    padding: '0 !important',
  },
  inputTelephone: {
    fontFamily: 'Inter',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0.02em',
    color: '#666666',
    width: '100%',
    borderRadius: '0',
    border: 'none',
    borderBottom: '1px solid #000',
    outline: 'none',
    paddingBottom: '8px',
    backgroundColor: 'transparent',
    height: '48px',

    '&:focus': {
      color: '#000',
      outline: 'none',
      boxShadow: 'none',
      borderBottom: '1px solid #FABA5A',
    },

    '&.danger': {
      borderColor: '1px solid #FF6363',
    },
  },
  phoneWrapper: {
    '& .react-tel-input .flag-dropdown': {
      paddingBottom: '8px',
      backgroundColor: 'transparent',
      border: 'none',
    },
    '& .react-tel-input .selected-flag': {
      padding: 0,
    },
    '& .react-tel-input .selected-flag:hover': {
      backgroundColor: 'transparent',
    },
    '& .react-tel-input .flag-dropdown.open .selected-flag': {
      backgroundColor: 'transparent',
    },
    '& .react-tel-input .selected-flag:focus::before': {
      boxShadow: 'none',
      border: 'none',
    },
    '& .react-tel-input .selected-flag.open::before ': {
      boxShadow: 'none',
      border: 'none',
    },
    '& .react-tel-input .form-control:focus': {
      boxShadow: 'unset',
      border: 'none',
      borderBottom: '1px solid #FABA5A !important',
    },
    '& .react-tel-input .special-label': {
      display: 'block',
      color: 'kit.text.secondary',
      fontFamily: 'Inter',
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '13px',
      lineHeight: '21px',
      letterSpacing: '0.03em',
      textAlign: 'left',
      position: 'absolute',
      top: '-5px',
      letterSpacing: '0.00938em',
      left: 0,
      background: 'none',
      padding: 0,
    },
  },
  errorMessage: {
    textAlign: 'left',
    width: '100%',
    display: 'inline-block',
    position: 'absolute',
    bottom: 0,
    transform: 'translateY(100%)',
    paddingTop: '4px',
    fontSize: '13px',
    lineHeight: '21px',
    left: 0,
    color: 'kit.text.error',
    fontFamily: 'Inter',
    letterSpacing: '0.03em',
  },
};

export default styles;
